/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
// import { LottiePlayer, useLottie } from "lottie-react"
// import Lottie, { useLottie } from "lottie-react"

// export default function LottieWrapper({ animationData, className = "" }) {
//   const options = {
//     animationData,
//     loop: true,
//   }

//   const { View } = useLottie(options)

//   return <div className={`lottie-wrapper ${className}`}>{View}</div>
// }

import { useEffect, useRef, useState } from "react"

export default function LottieWrapper({ animationData, className = "" }) {
  const ref = useRef()
  const [lottie, setLottie] = useState(null)

  useEffect(() => {
    import("lottie-web").then((Lottie) => setLottie(Lottie.default))
  }, [])
  useEffect(() => {
    if (lottie && ref.current) {
      const animation = lottie.loadAnimation({
        container: ref.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        // path to your animation file, place it inside public folder
        path: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      })
      return () => animation.destroy()
    }
  }, [lottie])

  return (
    <div className={`lottie-wrapper ${className}`}>
      <div ref={ref} />
    </div>
  )
}

// import { useRef, useEffect } from "react"

// export default function LottieWrapper({ animationData, className = "" }) {
//   const ref = useRef(null)
//   useEffect(() => {
//     import("@lottiefiles/lottie-player")
//   })
//   return (
//     <div className={`lottie-wrapper ${className}`}>
//       <lottie-player
//         id="firstLottie"
//         ref={ref}
//         autoplay
//         // controls
//         loop
//         mode="normal"
//         src={animationData}
//         // style={{ width: "300px", height: "300px" }}
//       />
//     </div>
//   )
// }

// import Lottie from "lottie-react-web"

// export default function LottieWrapper({ animationData, className = "" }) {
//   return (
//     <div className={`lottie-wrapper ${className}`}>
//       <Lottie
//         options={{
//           // animationData,
//           path: animationData,
//           loop: true,
//           autoplay: true,
//           rendererSettings: {
//             preserveAspectRatio: "xMidYMid slice",
//           },
//         }}
//       />
//     </div>
//   )
// }

// import { Player, Controls } from "@lottiefiles/react-lottie-player"

// export default function LottieWrapper({ animationData, className = "" }) {
//   return (
//     <div className={`lottie-wrapper ${className}`}>
//       <Player
//         autoplay
//         loop
//         src={animationData}
//         style={{ preserveAspectRatio: "xMidYMid slice" }}
//       >
//         {/* <Controls visible buttons={["play", "repeat", "frame", "debug"]} /> */}
//       </Player>
//     </div>
//   )
// }
